import axios from 'services/axios'
import Lessor from 'models/Lessor'

// Constant
import {
  API_LESSOR_COMPANY_LIST,
  API_LESSOR_CONTRACT_LIST,
  API_LESSOR_INFO,
  API_LESSOR_NAME_LIST,
  API_LESSOR_UPDATE,
  API_LESSOR_VENDOR_LIST,
  API_LESSOR_VERIFY,
} from 'constants/endpoints'

/**
 * Get list lessor name
 *
 * @returns {Array}
 */
export const getListLessors = async () => {
  try {
    const { data } = await axios.get(API_LESSOR_NAME_LIST)

    return data.map((x) => {
      return {
        value: x.id,
        label: x.name,
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get list company code
 *
 * @param {String|Number} lessorId
 * @returns {Array}
 */
export const getListCompanies = async (lessorId) => {
  try {
    const { data } = await axios.get(API_LESSOR_COMPANY_LIST, {
      params: {
        lessorId,
      },
    })

    return data.map((x) => {
      return {
        value: x.id,
        label: x.code,
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get list vendor code
 *
 * @param {Object} { lessorId, companyId }
 * @returns {Array}
 */
export const getListVendors = async ({ lessorId, companyId }) => {
  try {
    const { data } = await axios.get(API_LESSOR_VENDOR_LIST, {
      params: {
        lessorId,
        companyId,
      },
    })

    return data.map((x) => {
      return {
        value: x.id,
        label: x.code,
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
export const getLessorInfo = async (info) => {
  try {
    const { data } = await axios.get(API_LESSOR_INFO, {
      params: {
        lessorName: info.lessorName,
        companyId: info.companyId,
        vendorId: info.vendorId,
      },
    })
    return new Lessor(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get list contract number
 *
 * @param {Object} { lessorId, companyId, vendorId }
 * @returns {Array}
 */
export const getListContracts = async ({ lessorId, companyId, vendorId }) => {
  try {
    const { data } = await axios.get(API_LESSOR_CONTRACT_LIST, {
      params: {
        lessorId,
        companyId,
        vendorId,
      },
    })

    return data.map((x) => {
      return {
        value: x.contract_no,
        label: x.contract_no,
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateLessor = async (form) => {
  try {
    return await axios.post(API_LESSOR_UPDATE, form)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Verify lessor
 *
 * @param {Object} form {securityCode}
 * @return {Object}
 */
export const verifySecurityCode = async (form) => {
  try {
    await axios.post(API_LESSOR_VERIFY, form)
  } catch (error) {
    return Promise.reject(error)
  }
}
